import { Entity } from 'src/app/models/entities.model';
import { UserEntities } from 'src/app/models/Users';

export class UserHelper {

    static getPermissionEntities(permissions: UserEntities): Entity[] {
        const entities: Entity[] = [];
        if (!permissions) { return []; }
        Object.keys(permissions).forEach(key => {
            const o = permissions[key] || [];
            o.forEach(entity => entities.push(entity));
        });
        return entities;
    }

    static getEntityById(id: number, permissions: UserEntities) {
        const entities = UserHelper.getPermissionEntities(permissions);
        return entities.find(entity => entity.id == id);
    }
}
